var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.ideators.length)?_c('base-followers',{attrs:{"followers":_vm.ideators,"height-condition":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }